import { Button, Message } from 'react-bulma-components';
import { Note, Progression, Scale, ScaleType } from '@tonaljs/tonal';
import React, { useEffect, useState }  from 'react';

import AbcNotation from './abc-notation';
import Group from './group';
import { Notification } from 'react-bulma-components';
import Tippy from '@tippyjs/react';

const TooltipScale = ({ children, ...props }) => {

  const [tooltipVisible, setTooltipVisible ] = useState(false);
  let regex = /(?<romantonic>^(I{1,3}|IV|VI{0,2}){1}[#b]?)(\s|$)(?<name>.*)/;
  let match = regex.exec(children);
  
  var keytonic = props.t;
  var tonic = "";
  var name = props.n;
  if (match) {
    tonic = tonic || match.groups.romantonic;
    name = name || match.groups.name || "major";
  }
  tonic = Progression.fromRomanNumerals(keytonic, [tonic])[0];
  if(tonic.endsWith("#b") || tonic.endsWith("b#"))
  {
    tonic = tonic.substring(0, tonic.length-2);
  }
  tonic = Note.simplify(tonic);
  let scale = Scale.get(`${tonic}4 ${name}`.trim());

  if (scale.empty) {
    return (
      <Button size="small" rounded={true} color="danger">{tonic}-{name}</Button>
    )
  }
  else{
    let tonicSymbol = tonic.replace(/b/g, '♭')
    .replace(/#/g, '♯');
    if(props.pop===true){
      return (
        <Tippy placement="bottom-start" showOnCreate={false} trigger="click" animation={false} content={
              <Message color="success" size='small' style={{border: '1px solid hsl(171, 100%, 41%)'}}>
              <Message.Header>
              {tonicSymbol} {name} scale
              </Message.Header>
              <Message.Body style={{ color: 'black'}}>
              <div style={{width: "250px"}}></div>
              <AbcNotation scientificNotes={scale.notes} clef={props.clef} />
              </Message.Body>
            </Message>  
        }>
          <span tabIndex="0">
          <Button size="small" rounded={true} onClick={() => setTooltipVisible(!tooltipVisible)}>{tonicSymbol} {name}</Button>
      </span>  
      </Tippy>
      )
    }
    else{
      return (
        <Notification color="white" style={{ padding:0,  marginTop: 10, marginBottom: 10, marginRight: 0, minWidth:200, maxWidth: 240 }}>
          <AbcNotation scientificNotes={scale.notes} title={`${tonicSymbol} ${name} scale`} clef={props.clef}/>
        </Notification>
      )
    }
    
  }
}

export default TooltipScale;